<template xmlns="http://www.w3.org/1999/html">
  <div class="container">
    <nav class="nav">
      <ul class="nav_list">
       <li>
        <router-link to="/">Home</router-link>
       </li>
       <li>
        <router-link to="/registration">Registration</router-link>
       </li>
       <li>
        <router-link to="/sponsorship">Sponsorship</router-link>
       </li>
       <li>
        <router-link to="/program">Program</router-link>
       </li>
       <li>
        <router-link to="/speakers">Speakers</router-link>
       </li>
       <li>
        <router-link to="/abstract">Abstract</router-link>
       </li>
       <li>
        <router-link to="/venue">Venue</router-link>
       </li>
       <!-- <li>
         <router-link to="/lunImage">Photo</router-link>
       </li> -->
       <li>
         <div class="dropdown">
           <a href="#">History</a>
           <div class="dropdown-content">
             <a href="https://www.confrxiv.com/ICTP2022/" target="_blank">ICTP2023</a>
             <br>
             <a href="https://qaafi.uq.edu.au/event/session/14401" target="_blank">ICTP2024</a>
             <br>
             <a href="https://bioinformatics.hainanu.edu.cn/conf" target="_blank">ICTP2025</a>
           </div>
         </div>
       </li>
       <li>
        <router-link to="/download">Download</router-link>
       </li>
       <li>
         <router-link to="/call-for-pages">Call for Articles</router-link>
       </li>
       <li v-if="isAdmin">        
        <router-link :to="admin">Admin</router-link>
       </li>
      </ul>
    </nav>

    <div>
      <el-dropdown style="width: 150px; cursor: pointer; text-align: right" v-if="isAuthenticated">
      <div style="display: inline-block">
        <img :src="userImage"
             style="width: 30px; border-radius: 50%; position: relative; top: 5px; right: 5px" alt="">
        <span style="color: aliceblue; font-size: 15px">{{ username }}</span><i class="el-icon-arrow-down" style="margin-left: 5px"></i>
      </div>

      <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item style="font-size:18px;margin-top: 5px;">
              <router-link to="/person">Personal Center</router-link>
            </el-dropdown-item>
            <el-dropdown-item style="font-size:18px;margin-top: 5px;">
              <span style="text-decoration: none" @click="handleAuthClick">Log Out</span>
            </el-dropdown-item>
           
          </el-dropdown-menu>
        </template>  
      </el-dropdown>


      <!-- <el-button v-if="!isAuthenticated"
          class="auth-button"
          :round="true"
          :style="{ borderRadius: '50px' }"
          @click="handleAuthClick"
      >
        <b>Login</b>
      </el-button> -->


<!--      <el-button v-if="!isAuthenticated"
          class="auth-button"
          :round="true"
          :style="{ borderRadius: '50px' }"
          @click="handleRegisterClick"
      >
        <b>Register</b>
      </el-button>-->
    </div>
  </div>

  <el-carousel height="600px">
    <el-carousel-item>
      <div class="photo-box">
        <!-- 上述这里插入照片框的内容 -->
        <div class="photo-box-h">
          <h1>The 4<sup>th</sup> International Conference of<br> Tropical Plants (ICTP2026)</h1>
          <h2>Cultivating Climate-Smart Resilience for a Sustainable Bioeconomy</h2>
          <h3>March 23th - 25th, 2026, Thailand</h3>
          <br>
          <h4>Call for oral report and poster!</h4>
        </div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="photo-box-2" />
    </el-carousel-item>
  </el-carousel>

  <div class="outer-div">
    <div class="inner-div">
      <div class="vertical-line"></div>
      <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          :ellipsis="false"
          @select="handleSelect"
      >
        <h3>{{ $route.name || 'Default Name' }}</h3>
        <el-sub-menu style="padding-right: 10%;" index="2" v-if="$route.name === 'Admin' || $route.name === 'AdminAbstract' || $route.name === 'AdminLun'">
          <template #title>Workspace</template>
          <el-menu-item index="2-1">
            <router-link :to="admin">Admin</router-link>
          </el-menu-item>
          <el-menu-item index="2-2">
            <router-link :to="adminAbstract">AdminAbstract</router-link>
          </el-menu-item>
          <el-menu-item index="2-3">
            <router-link :to="adminLun">AdminLun</router-link>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import store from "../store";

export default {
  name: 'AuthComponent',
  computed: {
    store() {
      return store
    },
    ...mapGetters(['isAuthenticated', 'user']), // 映射 getters 到计算属性
    // 自定义计算属性，判断用户是否已登录
    isAuthenticated() {
      console.log("GIIIIII",this.user);
      return this.user && this.user.data; // 检查 user.data 是否存在
    },
      
    userImage() {
      return this.user && this.user.data && this.user.data.userImage; // 检查 user.data.image 是否存在
    },
    username() {
      return this.user && this.user.data && this.user.data.username; // 检查 user.data.name 是否存在
    },

    isAdmin(){
      return this.user && this.user.data && this.user.data.userRole === 'admin'; // 检查 user.data.isAdmin 是否存在
    }
  },
  mounted() {

  },
  data() {
    return {
     
      user2:{
        userName: '',
        userImage: '',
      },

      isLoggedIn: false, // 假设初始状态为未登录
      menuItems: [
        { label: 'Home', path: '/' },
        { label: 'Registration', path: '/registration' },
        { label: 'Program', path: '/program' },
        { label: 'Speakers', path: '/speakers' },
        { label: 'Abstract', path: '/abstract' },
        { label: 'Venue', path: '/venue' },
        { label: 'lunImage', path: '/lunImage' },
        { label: 'Call for Articles', path: '/call-for-pages' },
        { label: 'Download', path: '/download' },
        { label: 'Admin', path: '/admin' }
      ],
      admin:'/admin',
      adminAbstract: '/adminAbstract',
      adminLun: '/adminLun'
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      // 处理菜单选择事件
      console.log('Menu selected:', key, keyPath);
    },
    handleAuthClick() {
      if (this.isAuthenticated) {
        this.$store.dispatch('logout'); // 调用 logout action
        this.$router.push('/login');

      } else {
        // 跳转到登录页面或进行登录操作
        this.$router.push('/login');
      }
    },
    handleRegisterClick() {
      // 跳转到注册页面
      this.$router.push('/register');
    },
    handlePersonalCenter(){
      this.$router.push('/person');

    }
  },

  created(){
   
    //this.user2.userName = store.getters.user === null ? '未登录' : store.getters.user.data.userName,
    //this.user2.userImage = store.getters.user === null ? '' : store.getters.user.data.userImage,
    console.log("xxxxxxxxx", store.getters.user)
    this.user2.userName = store.getters.user === null ? '未登录' : store.getters.user.data.userName;
    this.user2.userImage = store.getters.user === null ? '' : store.getters.user.data.userImage;
  }
  
};
</script>

<style scoped>
.outer-div {
  text-align: center;
  position: relative;
  margin-top: 42px;
}

.outer-div::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 16%;
  width: 68%; /* 控制下划线的宽度 */
  border-bottom: 1px solid rgb(153,0,7); /* 红色下划线 */
}


.inner-div {
  display: flex;
  margin-left: 290px;
  align-items: center; /* 垂直居中 */
  font-size: 27px;
  h1 {
    margin: 0;
    padding-bottom: 10px; /* 调整标题与下划线的间隔 */
  }
}

.vertical-line {
  border-left: 7px solid rgb(153,0,7); /* 竖直线 */
  height: 65px; /* 根据需要调整高度 */
  margin-right: 40px;
}

.photo-box-h{
  h4{
    font-size: 40px;
    color: yellow;
    text-align: center; /* 水平居中对齐 */
    line-height: 1;   /* 行高，用于调整换行 */
    margin-top: 10px;
    margin-bottom: 0;
  }

  h3{
    font-size: 30px;
    color: white;
    text-align: center; /* 水平居中对齐 */
    line-height: 1;   /* 行高，用于调整换行 */
    margin-top: 10px;
    margin-bottom: 0;
  }

  h2{
    font-size: 30px;
    color: yellow;
    text-align: center; /* 水平居中对齐 */
    line-height: 1;   /* 行高，用于调整换行 */
    margin-top: 10px;
    margin-bottom: 0;
  }

  h1 {
    font-family: Verdana,serif;
    font-size: 70px;
    color: white;
    text-align: center; /* 水平居中对齐 */
    line-height: 2;   /* 行高，用于调整换行 */
    margin-bottom: 0;
  }

}

.photo-box {
  width: 100%;
  height: 600px; /* 根据需要设置具体的高度 */
  background-image: url('@/assets/images/background.jpg');
  background-size: cover; /* 使背景图适应容器 */
  background-position: center; /* 使背景图居中 */
  background-repeat: no-repeat; /* 防止背景图重复 */
  display: flex;
  justify-content: center;
}

.photo-box-2 {
  width: 100%;
  height: 600px; /* 根据需要设置具体的高度 */
  background-image: url('@/assets/images/banner.jpg');
  background-size: cover; /* 使背景图适应容器 */
  background-position: top; /* 使背景图贴着顶部 */
  background-repeat: no-repeat; /* 防止背景图重复 */
  display: flex;
  justify-content: center;
}

/*
.auth-buttons {
  display: flex;png
  align-items: center;
  width: 150px;
}
*/

.auth-button {
  margin-left: 10px;
  margin-right: 10px;
  width: 80px;
}

.container {
  background-color: rgb(22,84,133);
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav ul {
  list-style-type: none;
  margin: 0;
  padding-left: 300px;
  display: flex;
}

.nav li {
  margin: 0 10px;
}

.nav a {
  color: #fff;
  text-decoration: none;
  font-size: 18px;
}

.nav a:hover {
  text-decoration: underline;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: rgb(22,84,133);
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.el-menu--horizontal > .el-menu-item:nth-child(1) {
  margin-right: auto;
}
</style>
